import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { translate } from 'react-i18next'
import {} from 'react-router-dom'
import { TextInput, BirthdayInput, SelectInput, UploadAvatar } from '../UI'
import { Padding } from '../UI/StyledComponents'
import Form from '../UI/Form'
import { validateRequired, validateRequiredPhone, validateEmail } from './../../libs/validation'
import { graphql, gql, compose } from 'react-apollo'
import config from '../../config'
import getByPath from 'lodash/get'
import _ from 'lodash'
import get from 'lodash/get'
import { NotificationManager } from 'react-notifications'

import USER_QUERY from '../../graphql/UserByID.graphql'
import UPDATE_PROFILE from '../../graphql/Profile/UpdateUserProfile.graphql'
import { Loader } from '../UI'
import { changeAuthDetails } from '../../libs/authService'


class ProfilePage extends Component {
  static propTypes = {
    t: PropTypes.func,
    user: PropTypes.object
  }
  constructor(props) {
    super(props)
    this.state = {
      file: '',
      form: {},
      userProfile: this.props.user ? this.props.user.userProfile : null,
      avatar: this.props.user ? `${config.imgApiUrl}/${getByPath(this.props.user.userProfile, `imageAvatar.secret`, null)}/130x140` : null
    }
  }

  componentWillReceiveProps(props) {
    if (!this.props.userQuery.loading && this.props.userQuery.User) {
      this.updateStateFromProfile(this.props.userQuery.User.userProfile)
    }
    else if (!this.props.user && props.user) {
      this.updateStateFromProfile(props.user.userProfile)
    }
  }

  updateStateFromProfile(userProfile) {
    this.setState(
      {
        userProfile: userProfile,
        avatar: `${config.imgApiUrl}/${getByPath(userProfile, `imageAvatar.secret`, null)}/130x140`
      }
    )  
  }

  onFormFieldChange(id, value, callback) {
    console.log(id, value, callback)
    const form = _.set(this.state.form, id, value)

    this.setState({ form }, () => {
      if (callback) {
        callback()
      }
    })
  }
  getGenderOptions = () => {
    return [
      {
        label: 'male',
        value: 'male'
      },
      {
        label: 'female',
        value: 'female'
      },
      {
        label: 'other',
        value: 'other'
      }
    ]
  }
  getPrefferedLangOptions = () => {
    return [
      {
        label: 'English',
        value: 'english'
      },
      {
        label: 'Spanish',
        value: 'spanish'
      },
      {
        label: 'Hebrew',
        value: 'hebrew'
      }
    ]
  }
  getCurencyOptions = () => {
    return [
      {
        label: 'USD',
        value: 'usd'
      },
      {
        label: 'EURO',
        value: 'euro'
      },
      {
        label: 'YEN',
        value: 'yen'
      },
      {
        label: 'RAND',
        value: 'rand'
      }
    ]
  }
  getCountryOptions = () => {
    return [
      {
        label: 'USA',
        value: 'usa'
      },
      {
        label: 'Canada',
        value: 'canada'
      },
      {
        label: 'Israel',
        value: 'israel'
      },
      {
        label: 'South Africa',
        value: 'soth_africa'
      }
    ]
  }
  _handleImageChange(e) {
    e.preventDefault()
    let reader = new FileReader()
    let file = e.target.files[0]

    reader.onloadend = el => {
      if (file) {
        this.setState(
          {
            file: file,
            avatar: el.target.result
          },
          () => {
            console.log(this.state)
          }
        )
      }
    }
    reader.readAsDataURL(file)
  }

  refreshUser = () => {
    this.props.refreshUser(this.props.user.id)
  }

  async handleSubmit(data, user) {
    try {
      if (this.state.file !== '') {
        new Promise((resolve, reject) => {
          let data = new FormData()
          data.append('data', this.state.file)
          console.log(data)
          resolve(
            fetch(config.fileAPI, {
              method: 'POST',
              body: data
            })
          )
        })
          .then(response => {
            return response.json()
          })
          .then(res => {
            this.setState({ avatar: `${config.imgApiUrl}/${res.secret}/130x140` }, async () => {
              this.props
                .updateProfile({
                  variables: {
                    id: user.userProfile.id,
                    birthDate: data.birthDate,
                    email: data.email,
                    gender: data.gender,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    defaultLanguage: data.preffered_language,
                    phone: data.phone,
                    currency: data.currency,
                    country: data.country,
                    imgId: res.id
                  }
                })
                .then((result) => {
                  changeAuthDetails(this.props.userQuery.User.auth0UserId, data.email, data.phone)
                  this.setState({ saved: true })
                  this.refreshUser()
                  NotificationManager.success('Profile updated', 'Success', 5000)
                  this.props.history.push('/')
                })
            })
          })
      } else {
        this.props
          .updateProfile({
            variables: {
              id: user.userProfile.id,
              birthDate: data.birthDate,
              email: data.email,
              gender: data.gender,
              firstName: data.firstName,
              lastName: data.lastName,
              defaultLanguage: data.preffered_language,
              phone: data.phone,
              currency: data.currency,
              country: data.country
            }
          })
          .then((result) => {
            changeAuthDetails(this.props.userQuery.User.auth0UserId, data.email, data.phone)
            this.setState({ saved: true })
            this.refreshUser()
            NotificationManager.success('Profile updated', 'Success', 5000)
            this.props.history.push('/')
          })
      }
    } catch (e) {
      NotificationManager.error('Cant update profile', 'Error', 5000)
    }
  }
  render() {
    const { t } = this.props
    const { userProfile } = this.state

    if (this.props.loading || this.props.userQuery.loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col-md-1 col-md-offset-3">
            <h4>Edit Profile</h4>
          </div>
          <div className="col-md-6 ">
            <Form
              onSubmit={e => this.handleSubmit(e, this.props.user)}
              submitBtnClassname="btn btn-lg btn-primary btn-danger"
              submitBtnName={t('save')}
              // submittingToServer={saving}
            >
              <div className="panel panel-default" style={{ fontSize: '16px' }}>
                <div className="panel-body ">
                  <Padding size="0px 39px">
                    <div className="row">
                      <h1>{t('title')}</h1>

                      <hr />

                      <div className="form-horizontal event__form-container">
                        <div className="form-group">
                          <label htmlFor="sub-category" className="event__form-label col-md-3 control-label">
                            {t('pr_picture')}
                          </label>
                          <div className="col-md-9">
                            <UploadAvatar
                              id="photo"
                              onFileChange={e => {
                                this._handleImageChange(e)
                              }}
                              initialPhoto={this.state.avatar}
                              isGroup={false}
                              helpText={t('help_avatar')}
                              helpTextClassName={'profile_helptext'}
                            />
                          </div>
                        </div>

                        <TextInput
                          ref={input => (this.titleInput = input)}
                          label={t('first_name')}
                          labelClass="event__form-label col-md-3 control-label"
                          inputWrapperClass="col-md-9"
                          wrapperClass="form-group"
                          id="firstName"
                          initialValue={userProfile.firstName || ''}
                          validationFuncs={[validateRequired]}
                          extraClass="form-control event__form-input"
                          placeholder={t('first_name_placeholder')}
                        />

                        <TextInput
                          ref={input => (this.titleInput = input)}
                          label={t('last_name')}
                          labelClass="event__form-label col-md-3 control-label"
                          inputWrapperClass="col-md-9"
                          wrapperClass="form-group"
                          initialValue={userProfile.lastName || ''}
                          id="lastName"
                          extraClass="form-control event__form-input"
                          placeholder={t('last_name_placeholder')}
                          helpText={t('help_names')}
                          helpTextClassName={'profile_helptext'}
                        />

                        <div className="form-group">
                          <label htmlFor="sub-category" className="event__form-label col-md-3 control-label">
                            {t('birthday')}
                          </label>

                          <div className="col-md-9">
                            <BirthdayInput
                              id="birthDate"
                              isGroup={false}
                              helpText={t('help_birthday')}
                              initialValue={userProfile.birthDate || ''}
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="sub-category" className="event__form-label col-md-3 control-label">
                            {t('Gender')}
                          </label>
                          <div className="col-md-4 ">
                            <SelectInput
                              id="gender"
                              options={this.getGenderOptions()}
                              simpleValue
                              clearable={false}
                              isGroup={false}
                              initialValue={userProfile.gender || ''}
                              helpText={t('help_gender')}
                            />
                          </div>
                        </div>

                        <TextInput
                          ref={input => (this.titleInput = input)}
                          type="email"
                          label={t('email')}
                          labelClass="event__form-label col-md-3 control-label"
                          inputWrapperClass="col-md-9"
                          wrapperClass="form-group"
                          id="email"
                          initialValue={userProfile.email || ''}
                          extraClass="form-control event__form-input"
                          placeholder={t('email_placeholder')}
                          onChangeExternal={(id, value) => this.onFormFieldChange(id, value)}
                          validationFuncs={[validateEmail]}
                          helpText={t('help_email')}
                          helpTextClassName={'profile_helptext'}
                        />

                        <TextInput
                          ref={input => (this.titleInput = input)}
                          type="phone"
                          label={t('phone')}
                          labelClass="event__form-label col-md-3 control-label"
                          inputWrapperClass="col-md-9"
                          initialValue={userProfile.phone || ''}
                          wrapperClass="form-group"
                          id="phone"
                          extraClass="form-control event__form-input"
                          placeholder={t('phone_placeholder')}
                          onChangeExternal={(id, value) => this.onFormFieldChange(id, value)}
                          validationFuncs={[validateRequiredPhone]}
                          helpText={t('help_phone')}
                          helpTextClassName={'profile_helptext'}
                        />

                        <div className="form-group">
                          <label htmlFor="sub-category" className="event__form-label col-md-3 control-label">
                            {t('pref_language')}
                          </label>
                          <div className="col-md-9">
                            <SelectInput
                              id="preffered_language"
                              options={this.getPrefferedLangOptions()}
                              simpleValue
                              initialValue={userProfile.defaultLanguage || ''}
                              clearable={false}
                              isGroup={false}
                              helpText={t('help_language')}
                              helpTextClassName={'profile_helptext'}
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="sub-category" className="event__form-label col-md-3 control-label">
                            {t('pref_curency')}
                          </label>
                          <div className="col-md-9">
                            <SelectInput
                              id="currency"
                              options={this.getCurencyOptions()}
                              simpleValue
                              initialValue={userProfile.currency || ''}
                              clearable={false}
                              isGroup={false}
                              helpText={t('help_currency')}
                              helpTextClassName={'profile_helptext'}
                            />
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="sub-category" className="event__form-label col-md-3 control-label">
                            {t('country')}
                          </label>
                          <div className="col-md-9">
                            <SelectInput
                              id="country"
                              options={this.getCountryOptions()}
                              simpleValue
                              clearable={false}
                              isGroup={false}
                              initialValue={userProfile.country || ''}
                              helpTextClassName={'profile_helptext'}
                              helpText={t('help_country')}
                            />
                          </div>
                        </div>
                        {/*<button className="btn event__submit-btn"*/}
                        {/*onClick={this.onSubmit()}>{t('save')}</button>*/}
                      </div>
                    </div>
                  </Padding>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    )
  }
}

const enhance = compose(
  translate('profile'),
  graphql(USER_QUERY, {
    name: 'userQuery',
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  }),
  graphql(UPDATE_PROFILE, {
    name: 'updateProfile',
    options: props => ({
      fetchPolicy: 'no-cache'
    })
  })
)
export default enhance(ProfilePage)



// WEBPACK FOOTER //
// src/components/ProfilePage/ProfilePage.js